module.exports = __webpack_public_path__ + "static/media/levitating_fellow.51057147.png";